import React from "react";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonSelect from "../../../components/forms/CommonSelect";
import { handleChange } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function GerenciadorFiltros({ filtrosHook }) {
  const { filtros, setFiltros } = filtrosHook;
  const statusNotaFiscal = useTipos("status_nota_fiscal");

  React.useEffect(() => {
    if (statusNotaFiscal)
      setFiltros((prevValues) => ({ ...prevValues, status: "TODAS" }));
  }, [setFiltros, statusNotaFiscal]);

  return (
    <div className="row">
      <div className="col-md-3">
        <div className="mb-3">
          <CommonInputDate
            label="Período inicial"
            id="inicio"
            value={filtros.inicio}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="mb-3">
          <CommonInputDate
            label="Período final"
            id="fim"
            value={filtros.fim}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="mb-3">
          <CommonSelect
            label="Status"
            id="status"
            value={filtros.status}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
            data={statusNotaFiscal.map((statusNota) => ({
              text: statusNota.valor,
              id: statusNota.chave,
            }))}
          />
        </div>
      </div>
    </div>
  );
}

GerenciadorFiltros.propTypes = {
  filtrosHook: PropTypes.shape({
    filtros: PropTypes.object.isRequired,
    setFiltros: PropTypes.func.isRequired,
  }).isRequired,
};

export default GerenciadorFiltros;
